
import React, {useState, useRef, useEffect, useMemo, Fragment} from 'react';
import { useExpanded, useTable, useColumnOrder } from "react-table";
import {useStateContext} from '../context/StateContext';
import { screenPosition, deadlineObjectChecker, removeEmptyProperties, removeEmptyStrings } from '../lib/utils'; 
import { deadlineDataObject } from '../lib/tableData'; 
import VisDiv from './frontend_components/VisDiv';
import Link from 'next/link';
import Loading from './Loading';
import { urlFor } from '../lib/client';
import DeviceIcons from './DeviceIcons';

 

const RegisterTable = ({tableData, devices}) => {
    const {
        customer,
        client,
        LDB,
        site,
        setIndexPage,
        nonConformities,
        register,
        setDeviceEdit,
        setDuplicateDevice,
        //devices,
        currentTemplate,
        setCurrentDevice,
        setScreenPosition
    } = useStateContext();

    //console.log("IN TABLE", tableData)
    
      const allTemplateFields = [
        ...!Array.isArray(currentTemplate?.fields) ? [] : currentTemplate?.fields,
        ...!Array.isArray(currentTemplate?.locations) ? [] : currentTemplate?.locations,
        ...!Array.isArray(currentTemplate?.dates) ? [] : currentTemplate?.dates,
      ]

    const onClickDuplicateDevice = (e) => {
      e.stopPropagation();
      //console.log("duplicate")
      setCurrentDevice()
      setDuplicateDevice(true)
      setDeviceEdit(true)
      setIndexPage("DEVICE")
  }
    // <DeviceIcons device={device} nonConformities={nonConformities} duplicateFn={onClickDuplicateDevice}/> 
    //useEffect(()=>{console.log("triggered",tableData); setUpdatedTableData(tableData)},[tableData])

    const testing = false
    const data = useMemo(() => tableData?.data, [tableData?.data]);
    
      const defaultColumn = React.useMemo(
    () => ({
      minWidth: 30,
      width: 150,
      maxWidth: 400,
    }),
    []
  )

    
    const tdBackground = "white"

    function compare( a, b ) {
      if ( a?.order < b?.order ){
        return -1;
      }
      if ( a?.order > b?.order ){
        return 1;
      }
      return 0;
    }

    const columnsData = useMemo(
      () => tableData?.columns,
      [tableData?.columns]
    );

    const columns = !columnsData ? [{Header: "ID", accessor: "_id"}] : columnsData 


    
    useEffect(()=>{

      // ========== HIDE ARCHIVED FIELDS ===========
        const archievedTemplateFields = allTemplateFields?.filter((x)=>x?.status == "ARCHIVIATO")?.map((x)=>x?._id)
        
      // ========== HIDE EMPTY COLUMNS ===========
      const dataWithNoEmptyData = data?.map?.((x)=>{
          return removeEmptyStrings(x)
          
        })
      const columnsWithNoData = columns?.map?.((item)=>{
        const nData = dataWithNoEmptyData?.map?.((x)=>{
          const accessorData = x[item?.accessor]
          if(accessorData)return 1
          return 0
        })?.reduce((partialSum, a) => partialSum + a, 0)
        //const doc = {accessor: item?.accessor, nData: nData}
        if(item?.accessor == "info") return undefined
        if(nData !== 0 ) return undefined
        return item?.accessor
      })?.filter(x=>x)
 
      // =========================================
      const columnsToHide = [

        ...!Array.isArray(tableData?.hideColumns) ? [] : tableData?.hideColumns,
        //...!Array.isArray(columnsWithNoData) ? [] : columnsWithNoData
      ]
      if (columnsToHide) {
        columnsToHide.forEach(x=>toggleHideColumn(x,true))
      }
      changeOrder()
    },[data, currentTemplate, tableData?.hideColumns])

    useEffect(()=>{
      //console.log("colonne", columns)
    },[columns])

    const changeOrder = () => {
      if (!columnsData) return;
      const array = columnsData.map?.((item)=>{
          const order = () => {
            if(item?.accessor === "presidio") return 5
            if(item?.accessor === "esito") return 98
            if(item?.accessor === "info") return 99
            if(item?.accessor === "nonConformita") return 97
            if(item?.accessor === "_id") return 0
            if(item?.accessor === "info") return 0

            return item?.order
          }
        return(
        {
          ...item,
          order: order()
        }
      )})
      .sort(compare)
      .map?.(x=> x?.accessor)
      //console.log("Change order", array)
      setColumnOrder(array)
    }

    const info = (device, duplicateDevice) => {return (
      <div>
        <p>
          info
        </p>
      </div>
    )}
  
    const { getTableProps, getTableBodyProps, toggleHideColumn, headerGroups, rows, prepareRow, setColumnOrder } = 
      useTable({ columns, data }, useColumnOrder);

     // console.log("IN TABLE", columns, data)

      const testFunction = () => {
        //checking sub error
        //const deviceId = rows[0]?.original?.devices[0]?._id
        const deviceToCheck = "738b7103-2cd4-4604-8e9f-5dadb934c7cdn"
        const findDevice = rows?.find?.(x=>x?.original?._id == deviceToCheck)
        console.log("kwnfkwejdfn",{rows, findDevice})
      }
  return (
    
    <div className="App">
      <VisDiv rules={[testing]}><button onClick={testFunction}>test register table</button></VisDiv>
      <div className="container">
        <table {...getTableProps()}>
          <thead>

            {headerGroups.map?.((headerGroup, index) => (
              <tr key={index} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map?.((column, index) => {

                  const columnLabel = () => {
                    const header = () => {
                      const label = `${column?.render("Header")}`
                      if(label === "SCADENZA ESERCIZIO") return LDB("fields","assetExpiry")
                      if(label === "ANNO DI PRODUZIONE") return LDB("fields","productionYear")
                      if(label === "ESITO NEGATIVO") return LDB("fields","negativeOutcome")
                      if(label === "NON CONFORMITA'") return LDB("device","nonConformities")
                     
                      return label}

                    if(column?.symbol) {
                        const image = <img style={{marginLeft:"2px"}} className="rounded-lg w-full " src={(urlFor(column?.symbol).width(18)?.url())} alt="symbol" />
              
                        return (
                          <div key={index} style={{display:"inline"}}> 
                            {header()}
                            {image}
                          </div>
                       )
                    }
                    
                    return (
                      <Fragment key={index}>
                        {header()}
                      </Fragment>
        
                    )
                 
                  }
                  return (
                  <th key={index} style={{fontSize:"12px"}} {...column.getHeaderProps()}>
                    {columnLabel()}
                  </th>
                )})}
              </tr>
            ))} 
          </thead>
          <tbody {...getTableBodyProps()} style={{fontSize:"12px"}}>
            {rows.map?.((row, index) => {
              const rowColour = index % 2 ? "white":"#f3f4f3"
              prepareRow(row);
              const deviceId = row.original?._id
              const device = deviceId ? (!Array.isArray(devices) ? [] : devices?.find?.((x)=>x._id === deviceId)) : undefined
              const onRowClick = () => {
                setScreenPosition(screenPosition())
                setDuplicateDevice(false)
                setCurrentDevice(device)
                setDeviceEdit(false)
                setIndexPage("DEVICE")
                //onClick={onRowClick}
                console.log("row click", device)
                //<Link href={`/device`}>  
              }
              return (
                <Fragment key={index}>
                  <tr onClick={onRowClick} style={{backgroundColor: rowColour}} {...row.getRowProps()}  >
                    {row.cells.map?.((cell, index) => {
                     
                       const cellId = cell.column.id
                       const date = cell.value
                       const dataObject = device && currentTemplate ? deadlineDataObject(device, currentTemplate) : undefined
                       const isDeadline = !Array.isArray(dataObject) ? undefined : dataObject?.find?.(x=>cellId===x.accessor)
                       const dateObject = isDeadline?.dateObject
                       const header = cell?.column?.Header
                       //if(header == "PROSSIMO COLLAUDO ANNUALE") console.log("dmqwksdmqwkwqmnsd", cell?.column)
                       //const deadline1 = deadlineObjectChecker(dateObject, true)
                       // #deadlines
                       // #monthlyDeadline
                       const deadline = deadlineObjectChecker(
                        dateObject, 
                        true,
                        cell?.column?.monthlyDeadline
                       ) 
                       const color = isDeadline && deadline.color
                       const textColor = isDeadline && deadline?.textColor
                       const symbol = cell?.column?.symbol
                       const trueValue = cell?.column?.trueValue
               
                       //if(isDeadline)console.log("cuheicnucn", dateObject)
                       const value = () => {
                        const cellValue = () => {
                          const value = cell?.value
                          if(symbol && !value) {
                            const image = <img className="rounded-lg w-full " src={(urlFor(symbol).width(22)?.url())} alt="symbol" />
                            //const header = column.render("Header")
                            return (
                              <div> 
                                {image}
                              </div>
                           )
                          }
                          //console.log("ACCESSOR", cell)
                          if(header === "INFO") return info()
                          if(trueValue && !value) return trueValue
                          
                          return value
                        }
                        if(isDeadline) return deadline.date
                        if(header === "ESITO NEGATIVO") return (
                          <div key={index} style={{display:"flex", alignItems:"center", justifyContent:"center", }}>
                            {cellValue()}                            
                          </div>)
                        if(header === "INFO") return (
                          <div key={index} style={{display:"flex", alignItems:"center", justifyContent:"center", }}>
                            <div style={{marginLeft:"15px"}}>
                              <DeviceIcons registerTemplate={currentTemplate} hideDuplicateButton={true} device={device} register={register} nonConformities={nonConformities}/>
                            </div>
                          </div>)
                        return cellValue()
                       }
                      return(
                      <td key={index} style={{backgroundColor:color, color: textColor, borderRight: 1, borderRightColor: "#d1c5c5", borderRightStyle: "dotted"}}  {...cell.getCellProps()}> {value()} </td>
                    )})}
                  </tr>
                </Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default RegisterTable
